module.exports = __webpack_public_path__ + "img/6.9e0d5161.jpg";